//import api from '../../../../services/api';
import axios from 'axios';
import { currentHttpOptions } from '../../../utils';

const API_URL = '/api/v1/common';
/**
 * @returns {Promise<ApiCommon.GetHyperFindQueriesResponse>}
 */
export const getHyperFindQueries = () => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/GetHyperFindQueries`,
        currentHttpOptions());
}
